/**
 * 自动选择角色
 */
import { useNavigate } from 'react-router-dom'
import { getRolesApi } from '@/api/user'
import { actionTypes, useStoreDispatch, useStoreState } from '@/store'
import { isEmpty, getUrlParam } from '@/utils'

export const useSelectRole = () => {
  const dispatch = useStoreDispatch();
  const { inner } = useStoreState()
  const redirectUri = getUrlParam('redirectUri')
  const gameCode = getUrlParam('gameCode')
  const navigate = useNavigate();

  const getRoles = async () => {
    dispatch({ type: actionTypes.SET_PAGE_LOADING, payload: true })
    const res = await getRolesApi({ gameCode }).finally(() => dispatch({ type: actionTypes.SET_PAGE_LOADING, payload: false }))
    if (res?.code === 0) {
      selectRoles(res.data[0] || {});
    }
  }

  // 点击进入按钮 需要缓存选择的游戏信息 因为个人中心需要展示
  // 因为切换游戏需要加载对应的客服中心配置 而该配置放在了Layout 所以这里刷新页面进入初始化来加载
  const selectRoles = (role: any = {}) => {
    dispatch({ type: actionTypes.SET_ROLE, payload: role });
    isEmpty(role) ? localStorage.removeItem('role') : localStorage.setItem('role', JSON.stringify(role));

    /* 判断是否有重定向 */
    if (redirectUri) {
      return window.location.href = redirectUri
    }

    const query = inner.isFrom ? `?type=${inner.type}&kfId=${inner.kfId}` : ''
    navigate(`/${role.gameCode ?? ''}${query}`);
    dispatch({ type: actionTypes.SET_PAGE_LOADING, payload: true });
    setTimeout(() => {
      location.reload();
    }, 0)
  }

  return [getRoles] as const;
}
